export enum EModuleType {
  LE = 'LE',
  FRT = 'FRT',
  ART = 'ART',
  FIREARM = 'FIREARM',
  ANCILLARY = 'ANCILLARY',
}
